import React from 'react';
import ReactDOMServer from 'react-dom/server';

/**
 * Wrapper to turn a React component for a former Jade file into a Jade-like template function.
 * Given the arguments to the template, the returned function returns an HTML string equivalent to
 * the former Jade HTML.
 *
 * All usages should move away from this pattern and either call ReactDOMServer.renderToStaticMarkup
 * directly or render the component as part of a regular component.
 *
 * @deprecated
 */
export default function makeDeprecatedJadeStyleTemplate<T extends {}>(
  Component: React.ComponentType<T>
): (args?: T) => string {
  return (args: T) => ReactDOMServer.renderToStaticMarkup(<Component {...args} />);
}
